
export const _80z = { // オンライン決済情報

  _801: { // オンライン決済情報 公開鍵 履歴対象
    v0: {
      itlz: {
        _801t1100s: '',
        _801a1100k: -1,
        _801a2100s: ''
      },
      unqs: [
        '_801t1100s',
        '_801a1100k',
      ],
      fldz: {
        _801t1100s: { // 上位キー種別
          pfx: '',
        },
        _801a1100k: { // 上位キー
          pfx: '',
        },
        _801a2100s: { // 公開鍵
          pfx: '',
        },
      },
    },
  },

  _802: { // オンライン決済情報 秘密鍵 履歴対象
    v0: {
      itlz: {
        _802t1100s: '',
        _802a1100k: -1,
        _802a2100s: ''
      },
      unqs: [
        '_802t1100s',
        '_802a1100k',
      ],
      fldz: {
        _802t1100s: { // 上位キー種別
          pfx: '',
        },
        _802a1100k: { // 上位キー
          pfx: '',
        },
        _802a2100s: { // '秘密鍵'
          pfx: '',
        }
      },
    },
  },

  _81r: { // 決済アカウント情報（履歴対象外）
    v0: {
      itlz: {
        _81rt1100s: '',
        _81ra1100k: -1,
        _81ra2100s: '',
      },
      unqs: [ // 1支払者1 customer id
        '_81rt1100s',
        '_81ra1100k',
      ],
      fldz: {
        _81rt1100s: { // 支払者上位キー種別
          pfx: '',
        },
        _81ra1100k: { // 支払者上位キー
          pfx: '',
        },
        _81ra2100s: { // customer id
          pfx: '',
        },
      },
    },
  },

  _811: { // サブスクリプション情報（履歴対象外）
    v0: {
      itlz: {
        _811_81r1k: -1,
        _811d1100s: '',
        _811d2100s: '',
        _811d2200s: '',
        _811s1100i: -1,
        _811a1100s: '',
        _811a2100s: '',
        _811a3100s: '',
      },
      unqs: [
        '_811a1100s', // 1 ssnId
      ],
      fldz: {
        _811_81r1k: { // _81r
          pfx: '',
        },
        _811d1100s: { // pay date time
          pfx: '',
        },
        _811d2100s: { // subscription start date time
          pfx: '',
        },
        _811d2200s: { // subscription end date time
          pfx: '',
        },
        _811s1100i: { // subscription status
          pfx: '',
          ls: [
            { key: -1, pfx: '未購読' },
            { key:  1, pfx: '購読中' },
          ]
        },
        _811a1100s: { // subscription id
          pfx: '',
        },
        _811a2100s: { // price id
          pfx: '',
        },
        _811a3100s: { // coupon id
          pfx: '',
        },
      },
    },
  },

};
